import { useTranslation } from 'react-i18next';
import { useAppUrl } from '../lib/appUrl';

export default function CtaBanner() {
  const { t } = useTranslation();
  const appUrl = useAppUrl();
  return (
    <section className="bg-bg">
      <div className="mx-auto max-w-6xl px-4 py-20">
        <div className="relative overflow-hidden rounded-3xl border border-border bg-surface px-6 py-16 text-center">
          <div aria-hidden className="pointer-events-none absolute inset-0 bg-grid opacity-[0.15]" />
          <div
            aria-hidden
            className="pointer-events-none absolute inset-x-0 top-0 h-full opacity-40"
            style={{
              background:
                'radial-gradient(60% 80% at 50% 0%, var(--color-primary) 0%, transparent 60%)',
            }}
          />
          <div className="relative">
            <h2 className="text-3xl font-bold sm:text-4xl">{t('cta.title')}</h2>
            <p className="mt-4 text-text-muted">{t('cta.subtitle')}</p>
            <a
              href={appUrl()}
              className="mt-8 inline-block rounded-lg bg-primary px-8 py-3 text-base font-semibold text-primary-fg shadow-lg shadow-primary/25 transition hover:bg-primary-hover"
            >
              {t('cta.button')}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
